module.exports = __webpack_public_path__ + "static/media/Wailmer_gaussian2.b468d20e.png";